import { Box, DesktopModal, Flex, Group, IconFont, Radio, RadioGroup, Text } from '@byecode/ui'
import { useAtomAction, WorkflowRunType, WorkflowType } from '@lighthouse/shared'
import { useStore } from '@xyflow/react'
import { memo, useCallback } from 'react'

import { workflowAtomFamily } from '@/atoms/workflow/state'
import { useFlowContainerContext } from '@/contexts/FlowContext'

const options = [
    {
        label: '并行执行',
        value: WorkflowRunType.PARALLEL,
        description: '当该工作流被同时多次触发时，会并行执行。执行速度最快。'
    },
    {
        label: '顺序执行',
        value: WorkflowRunType.SEQUENTIAL,
        description: '当该工作流被同时多次触发时，会并行执行。执行速度最快。'
    },
    {
        label: '严格串行执行',
        value: WorkflowRunType.STRICT_SEQUENTIAL,
        description: '当该工作流被同时多次触发时，会按触发顺序依次执行（包含子流程）。'
    }
]

const FlowConfigure = memo(() => {
    const { id, runType, type, setIsChanged } = useFlowContainerContext()
    const { run: updateWorkflow } = useAtomAction(workflowAtomFamily(id))

    const handleChange = useCallback(
        (value: string) => {
            setIsChanged?.(true)
            updateWorkflow(draft => {
                if (!draft) {
                    return
                }
                draft.runType = value as WorkflowRunType
            })
        },
        [setIsChanged, updateWorkflow]
    )

    return (
        <Group
            label="运行方式"
            styles={{
                root: { padding: '0 !important' },
                wrapper: { padding: '0 !important', height: 32, marginBottom: 8 },
                collapse: { padding: '0 !important' }
            }}
        >
            <RadioGroup name="workWay" value={runType} disabled={type === WorkflowType.ACTION} onChange={handleChange}>
                {options.map(option => (
                    <Radio
                        key={option.value}
                        size="xs"
                        value={option.value}
                        styles={{ root: { alignItems: 'flex-start' }, radio: { marginTop: 2 } }}
                        label={
                            <Box>
                                <Text size={14} lineHeight="22px">
                                    {option.label}
                                </Text>
                                <Text size={14} lineHeight="22px" whiteSpace="normal" color="var(--color-gray-400)">
                                    {option.description}
                                </Text>
                            </Box>
                        }
                    />
                ))}
            </RadioGroup>
        </Group>
    )
})

export const FlowConfigureModal = () => {
    const rootEl = useStore(s => s.domNode)
    const { setModalState } = useFlowContainerContext()

    return (
        <DesktopModal
            open
            onClose={() => setModalState({})}
            title="流程设置"
            withOverlay={false}
            closeOnClickOverlay={false}
            trapFocus={false}
            width={360}
            target={rootEl}
            styles={{
                root: { pointerEvents: 'none' },
                modal: {
                    pointerEvents: 'initial',
                    position: 'absolute',
                    top: 60,
                    right: 12,
                    bottom: 12
                },
                body: {
                    padding: '16px 16px 68px 16px !important'
                }
            }}
            transition={{ from: { x: '100%' }, to: { x: '0%' } }}
        >
            <FlowConfigure />
        </DesktopModal>
    )
}
